import { defineMeta } from '@/registry/types';

export const dashboardExampleMeta = defineMeta({
  name: 'DashboardExample',
  level: 'page',
  category: 'example',
  classification: 'custom',
  description: 'Reference security dashboard page composed entirely from design-system components.',
  baseLibrary: 'custom',
  importPath: '@/pages/DashboardExample',
  supportedStates: ['default'],
  designTokens: ['colors', 'spacing', 'severity'],
  accessibility: ['Demonstrates landmark structure via DashboardLayout.'],
  usageExamples: ['<DashboardExample />'],
  antiPatterns: ['This is an example; copy patterns rather than importing into production as-is.'],
  llmSafe: false,
  whenToUse: ['Reference for building dashboards'],
  whenNotToUse: ['Directly in production without adapting data'],
});

export default dashboardExampleMeta;
